import React, { useState } from "react";
import "./qualification.css"

const Qualification = () => {
   const [toggleState, setToggleState] = useState(1);

   const toggleTab = (index) => {                                          // Toggle effect
      setToggleState(index);
   }

   return(
      <section className="qualification section">
         <h2 className="section__title">Portfolio</h2>
         <span className="section__subtitle">My Personal Journey</span>

         <div className="qualification__container container">
            <div className="qualification__tabs">
               <div className={
                     toggleState === 1 
                        ? "qualification__button qualification__active button--flex" 
                        : "qualification__button button--flex"
                     }
                   onClick={() => toggleTab(1)}>

                  <i className="uil uil-briefcase-alt qualification__icon"></i>
                  Experience
               </div>
               
               <div className={
                     toggleState === 2 
                        ? "qualification__button qualification__active button--flex" 
                        : "qualification__button button--flex"}

                        onClick={() => toggleTab(2)}
                     >
                     
                     <i className="uil uil-graduation-cap qualification__icon"></i>
                     Education
               </div>

            </div>

            {/* -------------------------------- Education ------------------------------- */}
            <div className="qualification__sections">
               <div className={
                     toggleState === 2 
                     ? "qualification__content qualification__content-active" 
                     : "qualification__content"}>
                  <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Post-Graduation Degree</h3>
                        <span className="qualification__subtitle">
                           <br/>
                           <h5 className="qualification__subtitle">Computer Software & Database Development</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2021 - 2023
                        </div>
                     </div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div>

                  {/* <div className="qualification__data">
                     <div></div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Other qualifications</h3>
                        <span className="qualification__subtitle">
                           India - University
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2021 - 2022
                        </div>
                     </div>
                  </div> */}

                  {/* <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Other education</h3>
                        <span className="qualification__subtitle">
                           Country - University
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2019 - 2020
                        </div>
                     </div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div> */}

                  <div className="qualification__data">
                     <div></div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Bachelor of Engineering</h3>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           {/* <h5 className="qualification__subtitle">Electronics & Communication</h5> */}
                           Bengaluru - India
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2013 - 2017
                        </div>
                     </div>
                  </div>
               </div>
               
               {/* ------------------------------- Experiences ------------------------------ */}
               <div className={
                     toggleState === 1
                     ? "qualification__content qualification__content-active" 
                     : "qualification__content"}>
                  <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Data Scientist</h3>
                        <h4 className="qualification__subtitle"><i>(Permanent Full time)</i></h4>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">AlumaPower Corp.</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           Nov 2023 - Present
                        </div>
                     </div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div>

                  <div className="qualification__data">
                     <div></div>                                                    {/*Required*/}

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Research Software Developer & Data Engineer</h3>
                        <h4 className="qualification__subtitle"><i>(Contract Full time)</i></h4>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">AlumaPower Corp.</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           May - Oct 2023
                        </div>
                     </div>
                  </div>

                  <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Research Software Developer & Data Engineer</h3>
                        <h4 className="qualification__subtitle"><i>(COOP)</i></h4>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">AlumaPower Corp.</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           Jan - April 2023
                        </div>
                     </div>
                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div>
                  
                  <div className="qualification__data">
                     <div></div>                                                    {/*Required*/}
                     
                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Research Software Developer & Data Engineer</h3>
                        <h4 className="qualification__subtitle"><i>(PartTime)</i></h4>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">AlumaPower Corp.</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           Sept - Dec 2022
                        </div>
                     </div>
                  </div>
                  
                  <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Research Software Developer & Data Engineer</h3>
                        <h4 className="qualification__subtitle"><i>(Internship)</i></h4>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">AlumaPower Corp.</h5>
                           Ontario - Canada
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           April - Sept 2022
                        </div>
                     </div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div>

                  <div className="qualification__data">
                     <div></div>                                                    {/*Required*/}

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Web Master & Data Analysis</h3>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">Genne DMCC</h5>
                           Bengaluru - India
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2018 - 2021
                        </div>
                     </div>
                  </div>

                  <div className="qualification__data">
                     <div>
                        <h3 className="qualification__title">Solutions Representative Engineer</h3>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">Hewlett-Packard Inc.</h5>
                           Bengaluru - India
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           2017 - 2018
                        </div>
                     </div>

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                  </div>
                  
                  <div className="qualification__data">
                     <div></div>                                                    {/*Required*/}

                     <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div>
                     <div>
                        <h3 className="qualification__title">Data Researcher & Analysis</h3>
                        <span className="qualification__subtitle">
                           {/* <br/> */}
                           <h5 className="qualification__subtitle">Team Lead (Intern)</h5>
                           Bengaluru - India
                        </span>
                        <div className="qualification__calendar">
                           <i className="uil uil-calendar-alt"></i>
                           Aug - Oct 2016
                        </div>
                     </div>

                     {/* <div>
                        <span className="qualification__rounder"></span>
                        <span className="qualification__line"></span>
                     </div> */}
                  </div>
                  
               </div>
            </div>
         </div>
      </section>
   );
};

export default Qualification;